import React from 'react';
import type { ImageUrlBlock } from '../../store/chatStore';
import { MessageFileItem } from './MessageFileItem';

interface ImageUrlContentProps {
  content: ImageUrlBlock;
}

const getNameFromUrl = (urlString: string): string => {
  try {
    const url = new URL(urlString);
    const pathname = url.pathname;
    const lastSegment = pathname.split('/').filter(Boolean).pop() || '';
    return decodeURIComponent(lastSegment || 'image');
  } catch {
    return 'image';
  }
};

export const ImageUrlContent: React.FC<ImageUrlContentProps> = ({
  content,
}) => {
  const fileName = getNameFromUrl(content.image_url);
  const handleDownload = () => {
    const link = document.createElement('a');
    link.href = content.image_url;
    link.download = fileName;
    document.body.appendChild(link);
    link.click();
    document.body.removeChild(link);
  };

  return (
    <MessageFileItem
      fileName={fileName}
      mimeType={undefined}
      previewUrl={content.image_url}
      onDownload={handleDownload}
      showDownload={false}
    />
  );
};
